export default "__VITE_PUBLIC_ASSET__7d04a25d__"